import { jsx as n } from "react/jsx-runtime";
import { createContext as e, useContext as r } from "react";
const s = {
  linkComponent: (t) => /* @__PURE__ */ n("a", { ...t, children: t.children }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  history: {}
}, c = e(s), o = () => r(c), a = () => {
  const { linkComponent: t } = o();
  return t;
}, m = () => {
  const { history: t } = o();
  return t;
};
export {
  s as DEFAULT_STATE,
  c as RouterAbstractionContext,
  a as useAbstractedLink,
  m as useAsbstractedHistory,
  o as useRouterAbstraction
};
